import { Box, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useRef } from "react";
import { darkerGrey, greenFilter, greyFilter, pinkFilter, red } from "../../shared/colours";
import { ThemeModeContext } from "../../shared/Theme";

const Speedo = (props) => {

	const themeModeContext = useContext(ThemeModeContext);
	
	const [ animatedValue, setAnimatedValue ] = useState(0);
	
	const needle = useRef(null);
	const archFull = useRef(null);
	
	let contrastingFilter = (themeModeContext.themeMode === "light")? greyFilter : greenFilter;
	
	useEffect(() => {
		setAnimatedValue(0);
		
		let percent = props.value / props.max;
		let rotation = -90 + (180 * percent);
		
		archFull.current.style.filter = (props.twoTone)? pinkFilter : contrastingFilter;
		
		needle.current.style.transform = `rotate(-90deg)`;
		let needleTimeout = setTimeout(() => {
			if (!needle.current) return;
			needle.current.style.transform = `rotate(${rotation}deg)`;
		}, 50);
		
		const increments = Math.floor(props.value / 20);
		let newAnimatedValue = increments;
		const animInterval = setInterval(() => {
			newAnimatedValue += increments;
			if (newAnimatedValue >= props.value) {
				newAnimatedValue = props.value;
				clearInterval(animInterval);
			}
			
			setAnimatedValue(newAnimatedValue);
		}, 50);
		
		return function cleanup() {
			clearTimeout(needleTimeout);
			clearInterval(animInterval);
		};
	}, [props.value, props.max, props.twoTone]);
	
	return (
		<Box
			sx={{
				height: "225px",
				width: "399px",
				overflow: "hidden",
				margin: "auto",
				transform: `scale(${props.scale})`
			}}
		>
			<img
				ref={archFull}
				alt="speedo full background"
				style={{
					position: "relative",
					top: "0",
					left: "0",
					filter: contrastingFilter
				}}
				src="arch_full.png"
			/>
			<img
				alt="speedo half background"
				style={{
					position: "relative",
					top: "-206px",
					left: "0",
					filter: contrastingFilter
				}}
				src="arch_half.png"
			/>
			<img
				ref={needle}
				alt="speedo needle"
				style={{
					position: "relative",
					top: "-390px",
					left: "183px",
					transform: "rotate(-90deg)",
					transformOrigin: "bottom center",
					transition: "all 1s cubic-bezier(.47,1.64,.41,.8)",
					filter: pinkFilter
				}}
				src="needle.png"
			/>
			<Typography
				sx={{
					position: "relative",
					top: "-550px",
					left: "0",
					width: "100%",
					textAlign: "center",
					fontSize: "2em",
					fontWeight: "bold",
					// textShadow: `1.5px 1.5px ${darkerGrey}`,
					color: red
				}}
			>
				{animatedValue}
			</Typography>
		</Box>
	);

}

export default Speedo;